import { createSelector, createFeatureSelector } from '@ngrx/store';

import { MapContextState, InteractionType } from '../../models';

export const getMapContextState = createFeatureSelector<MapContextState>('app-map-context');

export const getInteractionType = createSelector(
  getMapContextState,
  (store) => store.interactionType,
);

export const getPreviousInteractionType = createSelector(
  getMapContextState,
  (store) => store.previousInteractionType,
);

export const getCropFieldsEnabled = createSelector(
  getMapContextState,
  (store) => store.cropFieldsEnabled,
);

export const getBlightLayerEnabled = createSelector(
  getMapContextState,
  (store) => store.blightLayerEnabled,
);

export const getSoilAnalysesEnabled = createSelector(
  getMapContextState,
  (store) => store.soilAnalysesEnabled,
);

export const getRvoEnabled = createSelector(getMapContextState, (store) => store.rvoEnabled);

export const getSelectLastYearsFieldEnabled = createSelector(
  getMapContextState,
  (store) => store.selectLastYearsFieldEnabled,
);

export const isDrawing = createSelector(
  getInteractionType,
  (interactionType) =>
    interactionType === InteractionType.drawFeature ||
    interactionType === InteractionType.drawDivision ||
    interactionType === InteractionType.drawOverlap,
);

export const isModifying = createSelector(
  getInteractionType,
  (interactionType) => interactionType === InteractionType.modifyFeature,
);

export const isCloningRvo = createSelector(
  getInteractionType,
  (interactionType) => interactionType === InteractionType.cloneRvo,
);

export const isCloningLastYearsField = createSelector(
  getInteractionType,
  (interactionType) => interactionType === InteractionType.cloneFieldFromLastYear,
);

export const isSelectingCropField = createSelector(
  getInteractionType,
  (interactionType) => interactionType === InteractionType.selectCropField,
);

export const isSelectingSoilAnalysis = createSelector(
  getInteractionType,
  (interactionType) => interactionType === InteractionType.selectSoilAnalysis,
);

export const isLinkingSoilAnalysisToCropField = createSelector(
  getInteractionType,
  (interactionType) => interactionType === InteractionType.linkSoilAnalysisToCropField,
);

export const isCopyingShapefile = createSelector(
  getInteractionType,
  (interactionType) => interactionType === InteractionType.copyShapefileData,
);

export const isEditing = createSelector(
  isDrawing,
  isModifying,
  isCloningRvo,
  isCloningLastYearsField,
  isLinkingSoilAnalysisToCropField,
  isCopyingShapefile,
  (
    drawing,
    modifying,
    cloningRvo,
    cloningLastYearsField,
    linkingSoilAnalysisToCropField,
    copyingShapefile,
  ) =>
    drawing ||
    modifying ||
    cloningRvo ||
    cloningLastYearsField ||
    linkingSoilAnalysisToCropField ||
    copyingShapefile,
);

export const getShapefileFeatures = createSelector(
  getMapContextState,
  (store) => store.shapefileFeatures,
);
